import { render, staticRenderFns } from "./maijia-head.vue?vue&type=template&id=69dc68b5&scoped=true&"
import script from "./maijia-head.vue?vue&type=script&lang=js&"
export * from "./maijia-head.vue?vue&type=script&lang=js&"
import style0 from "./maijia-head.vue?vue&type=style&index=0&id=69dc68b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc68b5",
  null
  
)

export default component.exports